var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestaurantMapGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 35 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0943 33.9087C28.6945 32.1365 34.3561 25.3187 34.3561 17.1786C34.3561 7.6911 26.6652 0 17.1781 0C7.69088 0 0 7.6911 0 17.1786C0 25.3188 5.6617 32.1366 13.262 33.9087L15.7301 38.1672C16.3736 39.2776 17.9826 39.2776 18.6261 38.1672L21.0943 33.9087Z",
    fill: "#A4A4A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5268 10.5271C16.5268 12.5257 15.1381 14.1459 13.425 14.1459C11.712 14.1459 10.3232 12.5257 10.3232 10.5271C10.3232 8.52842 11.712 6.9082 13.425 6.9082C15.1381 6.9082 16.5268 8.52842 16.5268 10.5271Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5262 14.0264C14.5156 13.5179 14.1004 13.1113 13.5919 13.1113C13.0834 13.1113 12.6682 13.5179 12.6576 14.0263L12.4202 25.3566C12.4064 26.0131 12.9349 26.5528 13.5916 26.5528C14.2482 26.5528 14.7767 26.0132 14.763 25.3566L14.5262 14.0264Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2188 7.59573C23.2006 7.20539 22.872 6.90218 22.4815 6.91538C22.091 6.92858 21.7836 7.25327 21.7918 7.64394L22.1694 25.6261C22.1805 26.1519 22.6191 26.5672 23.1447 26.5494C23.6703 26.5317 24.0799 26.0877 24.0555 25.5624L23.2188 7.59573Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6505 7.63829C20.6552 7.24756 20.345 6.92565 19.9544 6.91597C19.5637 6.90629 19.2379 7.21242 19.2232 7.60288L18.5477 25.5764C18.5279 26.1019 18.9416 26.5421 19.4673 26.5552C19.9929 26.5682 20.4279 26.149 20.4342 25.6232L20.6505 7.63829Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantMapGray);
export default __webpack_public_path__ + "static/media/Restaurant_map_gray.a80da7b4f631e230ab9afc4a78cc450c.svg";
export { ForwardRef as ReactComponent };